<template>
  <article
    class="col-xs-12 col-sm-6 br-10 SisrCard shadow-sm SisrAlert text-center"
  >
    <header class="d-flex align-items-center text-left">
      <font-awesome-icon icon="exclamation-circle" class="mr-2" />
      <span>
        <span class="font-weight-bold">{{ title }}</span
        >:&nbsp;{{ description }}
      </span>
    </header>
    <button
      class="btn btn-danger m-auto"
      style="margin-top: 12.5px !important"
      @click="btn.action"
    >
      <span>
        <font-awesome-icon v-if="btn.icon" :icon="btn.icon" class="mr-2" />
        {{ btn.label }}
      </span>
    </button>
  </article>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    btn: {
      type: Object,
      default: () => ({
        label: "Home",
        icon: null,
        action: () => {},
      }),
    },
  },
};
</script>
